import React from "react";

import { DeviceStatus } from "gql/generated/types";
import { Tag } from "primereact/tag";
import { T } from "services/lang/LanguageService";
import { DATE_FORMATTER_MINUTES } from "utils/constants";
import { formatDisplayDatetime, parseToLocalZoneDateTime } from "utils/time-utils";
import { useTimezone } from "../../../../hooks/useTimezone";

const DeviceStatusTag: React.FC<{ status?: DeviceStatus; lastMeasurementDate?: string }> = ({
  status,
  lastMeasurementDate,
}) => {
  const tz = useTimezone();
  const formatLastMeasurementDate = lastMeasurementDate && formatDisplayDatetime(lastMeasurementDate, tz.display);
  const lastMeasDateString = `${T("mdm.last-measurement")}: ${formatLastMeasurementDate}`
  switch (status) {
    case "OFFLINE":
      return <Tag value="Offline" severity="danger" title={lastMeasDateString} />;
    case "ONLINE":
      return <Tag value="Online" severity="success" title={lastMeasDateString} />;
    default:
      return <Tag value="N/A" className="bg-gray-500" />;
  }
};

export default DeviceStatusTag;